import {
  GetterTree, Module, MutationTree
} from 'vuex'
import { PageModule } from '../../ts/interfaces/page-modules'
import { RootState } from '..'

export interface PageModulesState {
  waiting: PageModule[]
  end: PageModule[]
}

const pageModulesState: PageModulesState = {
  waiting: [],
  end: [],
}

const mutations: MutationTree<PageModulesState> = {
  SET_PAGE_MODULES_WAITING(state: PageModulesState, waiting) {
    state.waiting = waiting
  },
  SET_PAGE_MODULES_END(state: PageModulesState, end) {
    state.end = end
  },
}

const getters: GetterTree<PageModulesState, RootState> = {
  pageModulesWaiting: (state: PageModulesState) => state.waiting,
  pageModulesEnd: (state: PageModulesState) => state.end,
}

export const pageModulesModule: Module<PageModulesState, RootState> = {
  state: pageModulesState,
  mutations,
  getters,
}
